import { useUserContext } from "@/context/UserContext";
import { CurrentUserI } from "@/interfaces/User";
import Link from "next/link";
import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown } from "react-icons/fa6";
const userIcon = "../../assets/images/icons/user-gray-icon.svg";
const signOutIcon = "../../assets/images/icons/sign-out-icon.svg";

const userAvatarDefault = "../../assets/images/placeholder-image.png";
interface IUserView {
  currentUser: CurrentUserI;
}

export const UserView = ({ currentUser }: IUserView) => {
  const { handleLogout } = useUserContext();
  const [show, setShow] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setShow(false);
      }
    };

    // Attach listener when mounted
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={containerRef}>
      <div
        className="flex cursor-pointer items-center gap-2"
        onClick={() => setShow(!show)}
      >
        <img
          src={
            currentUser.avatar !== "none"
              ? currentUser.avatar
              : userAvatarDefault
          }
          className="w-[40px] h-[40px] min-w-[40px] rounded-full"
          alt={currentUser.name}
        />
        <FaChevronDown className="w-[16px] min-w-[16px]" />
      </div>
      <div
        className={`duration-300 w-[240px] px-[20px] rounded-xl z-50 justify-center absolute top-[50px] right-0 overflow-hidden bg-black flex flex-col ${
          show ? " max-h-[150px] " : "max-h-[0px]"
        }`}
      >
        <Link
          href={"/profile"}
          onClick={() => setShow(false)}
          className="flex items-center gap-3 text-[#777e90] border-b py-3 border-[#777e90]"
          role="button"
        >
          <img src={userIcon} alt="user" />
          <p className="text-[#777e90]">My profile</p>
        </Link>
        {currentUser.admin > 0 && (
          <Link
            href={currentUser.admin === 3 ? "/admin/users" : "/admin"}
            role="button"
            onClick={() => setShow(false)}
            className="flex items-center gap-3 text-[#777e90] border-b py-3 border-[#777e90]"
          >
            <img src={userIcon} alt="user" />
            <p className="text-[#777e90]">Administrator</p>
          </Link>
        )}
        <div
          role="button"
          className="flex items-center gap-3 py-3 text-[#777e90]"
          onClick={() => {
            handleLogout();
            setShow(false);
          }}
        >
          <img src={signOutIcon} alt="user" />
          <p className="text-[#777e90]">Sign out</p>
        </div>
      </div>
    </div>
  );
};
